/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Aside_Coach_TitleInputs */

const en_contact_aside_coach_title = /** @type {(inputs: Contact_Aside_Coach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking for your coach?`)
};

const pl_contact_aside_coach_title = /** @type {(inputs: Contact_Aside_Coach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukasz swojego trenera?`)
};

/**
* | output |
* | --- |
* | "Looking for your coach?" |
*
* @param {Contact_Aside_Coach_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_aside_coach_title = /** @type {((inputs?: Contact_Aside_Coach_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Aside_Coach_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_aside_coach_title(inputs)
	return en_contact_aside_coach_title(inputs)
});